import { useState } from 'react';
import { Brand, CustomerMark } from '../components/Brand';
import { Icon } from '../components/Icon';
import { useSession } from '../state/SessionContext';

export function SignIn(): JSX.Element {
  const { authMode, signIn } = useSession();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (): Promise<void> => {
    setBusy(true);
    setError(null);
    const err = await signIn(email.trim(), name.trim(), code);
    setBusy(false);
    if (err) setError(err);
  };

  return (
    <div className="gate-shell">
      <header className="gate-head">
        <Brand />
        <span className="gate-head__sep" />
        <CustomerMark />
      </header>
      <div className="gate-body">
        <div className="gate-card">
          <h1 className="gate-title">Sign in</h1>
          <p className="gate-lead">
            For UltraTech programme staff. Every farm in the thirteen programme villages, who holds it, and how far each
            farmer has come on WhatsApp.
          </p>
          <div className="field-grid">
            <div className="fieldset" style={{ gridColumn: '1 / -1' }}>
              <label htmlFor="si-email">Work e-mail<span className="required">*</span></label>
              <input id="si-email" className="input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@adityabirla.com" inputMode="email" autoComplete="email" />
            </div>
            <div className="fieldset">
              <label htmlFor="si-name">Your name</label>
              <input id="si-name" className="input" value={name} onChange={(e) => setName(e.target.value)} placeholder="As farmers know you" />
            </div>
            {authMode !== 'disabled' ? (
              <div className="fieldset">
                <label htmlFor="si-code">Access code<span className="required">*</span></label>
                <input id="si-code" className="input" value={code} onChange={(e) => setCode(e.target.value)} type="password" autoComplete="off" />
                <span className="fieldset__hint">Given by the programme administrator.</span>
              </div>
            ) : null}
          </div>
          {authMode === 'unconfigured' ? (
            <div className="rule-note"><Icon name="alert" size={16} /><span><strong>Sign-in is not set up yet.</strong> Set <code>PORTAL_ACCESS_CODE</code> on the server.</span></div>
          ) : null}
          {error ? <p className="pay-error" style={{ textAlign: 'left', marginTop: 12 }}>{error}</p> : null}
          <div className="btn-row">
            <span className="btn-row__spacer" />
            <button type="button" className="btn-primary" disabled={busy || !email.includes('@') || (authMode !== 'disabled' && !code)} onClick={() => void submit()}>
              {busy ? 'Signing in…' : 'Open the portal'}
            </button>
          </div>
          <ul className="signin-points">
            <li><Icon name="check" size={15} /><span>Boundaries, owners and areas come from the state revenue record. Nothing on a farm is invented.</span></li>
            <li><Icon name="check" size={15} /><span>Onboarding stages are what the AI Bhoomi WhatsApp bot recorded, plus what field officers enter here.</span></li>
            <li><Icon name="check" size={15} /><span>Every farm carries one coordinate that lies inside its own boundary; every farmer's pin is checked against it.</span></li>
          </ul>
        </div>
      </div>
    </div>
  );
}
